// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import styles from '../styles/Table.scss';

type Props = {
  columns: Object[],
  data: Object[],
  print: boolean,
}

/*
  Wrapper around react-table to give default styles.
  Hides pagination and instead makes the table scrollable with all results
  Not sustainable if results too numerous (would want to reintroduce pagination),
  but should be ok for EHR use.

  For read-only tables that don't need edit functionality.
  Or for custom extensions via custom columns.
*/
class SimpleTableComponent extends Component<Props> {
  render() {
    const { columns, data, ...rest } = this.props;

    if (this.props.print && !data.length) {
      return 'No data';
    }

    return (
      <ReactTable
        columns={columns}
        data={data}
        className="-striped -highlight"
        style={{
          maxHeight: '250px',
        }}
        showPagination={false}
        // if no results, table height 3 to display no rows text
        pageSize={data.length ? data.length : 2}
        NoDataComponent={() => <div className={styles.noDataComponent}>No rows found</div>}
        {...rest}
      />
    );
  }
}

const mapStateToProps = state => ({
  print: state.patient.print,
});

const SimpleTable = connect(
  mapStateToProps,
)(SimpleTableComponent);

export default SimpleTable;



// WEBPACK FOOTER //
// ./client/src/components/SimpleTable.jsx